"use strict";

var _core = require("@emotion/core");

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePicker = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var core_1 = require("@emotion/core");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var core_2 = require("@material-ui/core");

require("date-fns");

var pickers_1 = require("@material-ui/pickers");

var date_fns_1 = __importDefault(require("@date-io/date-fns"));

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

exports.DatePicker = utils_2.forwardRef(function DatePicker(props, ref) {
  var onChange = props.onChange,
      _a = props.width,
      width = _a === void 0 ? '100%' : _a,
      format = props.format,
      value = props.value,
      open = props.open,
      InputFieldComponent = props.InputFieldComponent,
      keyboard = props.keyboard,
      maxDate = props.maxDate,
      minDate = props.minDate,
      disabled = props.disabled,
      closeOnSelect = props.closeOnSelect,
      inputValue = props.inputValue;
  var customTheme = core_2.createMuiTheme({
    palette: {
      primary: {
        main: '#22AA5F',
        light: '#22AA5F',
        dark: '#22AA5F'
      },
      secondary: {
        main: '#22AA5F'
      }
    }
  });
  var pickerStyle = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\n\t\tsvg {\n\t\t\tfont-size: 0.9rem !important;\n\t\t}\n\n\t\tbutton .MuiPickersDay-daySelected {\n\t\t\tbackground-color: #22aa5f !important;\n\t\t}\n\n\t\t.MuiPickersCalendarHeader-dayLabel {\n\t\t\tcolor: #1a2834 !important;\n\t\t\tfont-size: 0.75em !important;\n\t\t\tfont-weight: 600 !important;\n\t\t}\n\n\t\t.MuiTypography-root MuiTypography-body2 {\n\t\t\tfont-weight: 600 !important;\n\t\t\tcolor: #54666f !important;\n\t\t\tfont-size: 0.75em !important;\n\t\t}\n\n\t\t.MuiPickersCalendarHeader-transitionContainer > p {\n\t\t\tfont-weight: 800 !important;\n\t\t\tcolor: #54666f !important;\n\t\t\tfont-size: 1.125em !important;\n\t\t}\n\n\t\t.MuiInputBase-input {\n\t\t\tborder: solid 1px #e3e6e8 !important;\n\t\t\tborder-radius: 4px !important;\n\t\t\twidth: 100% !important;\n\t\t\tpadding: 0.875em 1em !important;\n\t\t\tjustify-content: space-between !important;\n\t\t\ttransition: all 0.1s ease-in-out !important;\n\t\t\tmin-height: 45px;\n\t\t\t&:focus {\n\t\t\t\toutline: none;\n\t\t\t}\n\t\t}\n\n\t\t.MuiInput-underline:before,\n\t\t.MuiInput-underline:after {\n\t\t\tdisplay: none !important;\n\t\t}\n\n\t\t.MuiIconButton-label > svg {\n\t\t\tcolor: #22aa5f;\n\t\t\tfont-size: 0.675em !important;\n\t\t}\n\n\t\t.MuiInputAdornment-positionEnd {\n\t\t\tmargin-left: -2.313em !important;\n\t\t}\n\n\t\t.MuiTouchRipple-root {\n\t\t\tdisplay: none !important;\n\t\t}\n\n\t\t.MuiIconButton-root:hover {\n\t\t\tbackground-color: transparent !important;\n\t\t}\n\n\t\t.MuiGrid-spacing-xs-3 > .MuiGrid-item {\n\t\t\tpadding: 0.938em 0.625em !important;\n\t\t}\n\n\t\t.MuiFormControl-root {\n\t\t\twidth: ", " !important;\n\t\t}\n\n\t\t.MuiFormControl-marginNormal {\n\t\t\tmargin: 0 !important;\n\t\t}\n\t"], ["\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\n\t\tsvg {\n\t\t\tfont-size: 0.9rem !important;\n\t\t}\n\n\t\tbutton .MuiPickersDay-daySelected {\n\t\t\tbackground-color: #22aa5f !important;\n\t\t}\n\n\t\t.MuiPickersCalendarHeader-dayLabel {\n\t\t\tcolor: #1a2834 !important;\n\t\t\tfont-size: 0.75em !important;\n\t\t\tfont-weight: 600 !important;\n\t\t}\n\n\t\t.MuiTypography-root MuiTypography-body2 {\n\t\t\tfont-weight: 600 !important;\n\t\t\tcolor: #54666f !important;\n\t\t\tfont-size: 0.75em !important;\n\t\t}\n\n\t\t.MuiPickersCalendarHeader-transitionContainer > p {\n\t\t\tfont-weight: 800 !important;\n\t\t\tcolor: #54666f !important;\n\t\t\tfont-size: 1.125em !important;\n\t\t}\n\n\t\t.MuiInputBase-input {\n\t\t\tborder: solid 1px #e3e6e8 !important;\n\t\t\tborder-radius: 4px !important;\n\t\t\twidth: 100% !important;\n\t\t\tpadding: 0.875em 1em !important;\n\t\t\tjustify-content: space-between !important;\n\t\t\ttransition: all 0.1s ease-in-out !important;\n\t\t\tmin-height: 45px;\n\t\t\t&:focus {\n\t\t\t\toutline: none;\n\t\t\t}\n\t\t}\n\n\t\t.MuiInput-underline:before,\n\t\t.MuiInput-underline:after {\n\t\t\tdisplay: none !important;\n\t\t}\n\n\t\t.MuiIconButton-label > svg {\n\t\t\tcolor: #22aa5f;\n\t\t\tfont-size: 0.675em !important;\n\t\t}\n\n\t\t.MuiInputAdornment-positionEnd {\n\t\t\tmargin-left: -2.313em !important;\n\t\t}\n\n\t\t.MuiTouchRipple-root {\n\t\t\tdisplay: none !important;\n\t\t}\n\n\t\t.MuiIconButton-root:hover {\n\t\t\tbackground-color: transparent !important;\n\t\t}\n\n\t\t.MuiGrid-spacing-xs-3 > .MuiGrid-item {\n\t\t\tpadding: 0.938em 0.625em !important;\n\t\t}\n\n\t\t.MuiFormControl-root {\n\t\t\twidth: ", " !important;\n\t\t}\n\n\t\t.MuiFormControl-marginNormal {\n\t\t\tmargin: 0 !important;\n\t\t}\n\t"])), width);

  var onChangeEvent = function onChangeEvent(date) {
    if (onChange) {
      onChange(date);
    }
  };

  var params = {};

  if (open) {
    params.open = true;
  }

  if (InputFieldComponent) {
    params.InputFieldComponent = InputFieldComponent;
  }

  return (0, _core.jsx)(core_2.MuiThemeProvider, {
    theme: customTheme
  }, (0, _core.jsx)(lseds_1.lseds.div, {
    css: pickerStyle
  }, (0, _core.jsx)(pickers_1.MuiPickersUtilsProvider, {
    utils: date_fns_1["default"]
  }, keyboard ? (0, _core.jsx)(pickers_1.KeyboardDatePicker, _extends({
    ref: ref,
    autoOk: !!closeOnSelect,
    inputValue: inputValue,
    disabled: disabled,
    maxDate: maxDate,
    minDate: minDate,
    disableToolbar: true,
    format: format,
    margin: "normal",
    value: value,
    onChange: function onChange(e) {
      return onChangeEvent(e);
    }
  }, params, {
    variant: open ? 'static' : 'inline',
    keyboardIcon: (0, _core.jsx)(react_fontawesome_1.FontAwesomeIcon, {
      icon: "calendar-alt"
    })
  })) : (0, _core.jsx)(pickers_1.DatePicker, _extends({
    ref: ref,
    disabled: disabled,
    maxDate: maxDate,
    inputValue: inputValue,
    minDate: minDate,
    disableToolbar: true,
    format: format,
    margin: "normal",
    value: value,
    onChange: function onChange(e) {
      return onChangeEvent(e);
    }
  }, params, {
    variant: open ? 'static' : 'inline',
    autoOk: !!closeOnSelect
  })))));
});

if (utils_1.isDev) {
  exports.DatePicker.displayName = 'DatePicker';
}

var templateObject_1;